import React from "react";

const MaintainScreen = () => {
  return (
    <div className="center-maintain">
      Server is Down. Please try again later.
    </div>
  );
};

export default MaintainScreen;
